/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        'class':'swiper-wrap',
        $html:[{
            'class':'swiper-container',
            id:nb.bind('swiperId'),
            style:{
                height:nb.bind('height')
            },
            $html:{
                'class':'swiper-wrapper',
                $type:nb.view.List,
                $model:''
            }
        },{
            'class':'swiper-pagination'
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/swiper/Swiper.js
// module id = 82
// module chunks = 6 17 24 31 33